import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { SearchResultsRepositoryService } from '../../services/search-results/search-results-repository.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'lib-download-parsed-result',
  templateUrl: './download-parsed-result.component.html',
  styleUrl: './download-parsed-result.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DownloadParsedResultComponent {
  private readonly transloco = inject(TranslocoService);
  @Input({ required: true }) orderID!: string;
  private _documentName?: string;
  @Input() set documentName(value: string | null | undefined) { this._documentName = value ?? undefined; }
  get documentName(): string { return this._documentName ?? this.transloco.translate('downloadParsedResult.parsedResult'); }

  constructor(private searchResultsRepo: SearchResultsRepositoryService) { }

  downloadParsedResult() {
    //Get Document
    this.searchResultsRepo.getParsedResults(this.orderID)
      .subscribe(result => {
        const documentType = `application/json" }`.toLowerCase();
        const blob = new Blob([JSON.stringify(result)], { type: documentType });
        const blobURL = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobURL;
        link.download = `${this.orderID}-ParsedResult.json`; // set a name for the file
        link.click();
      });
  }
}